import script from "./LoaderBanner.vue?vue&type=script&setup=true&lang=js"
export * from "./LoaderBanner.vue?vue&type=script&setup=true&lang=js"

import "./LoaderBanner.vue?vue&type=style&index=0&id=e8db4a64&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e8db4a64"]])

export default __exports__